<template>
  <div class="scrollable">
    <p v-if="!receivedHistories.length" class="t-c" style="margin-top:10px;">还没有任何收入记录哦~</p>
    <gift-item v-for="(item,index) in receivedHistories"
      :item="item" :key="item.id" :selectable="multi" :checked="selections&&selections.indexOf(index)>-1"
      v-longpress="()=>$emit('longpress', item)"
      @click="$router.push('/edit-history/' + item.id + '?type=received')"
      @change="checked=>$emit('change',index,checked)"></gift-item>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import GiftItem from '@/components/GiftItem'
export default {
  props: {
    multi: Boolean,
    selections: Array
  },
  computed: {
    ...mapGetters(['receivedHistories'])
  },
  components: {
    GiftItem
  }
}
</script>



// WEBPACK FOOTER //
// Received.vue?58f1c156